// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableHead(theme) {
  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: theme.vars.palette.primary.lighter,
          borderTop: 'none',
          borderBottom: '2px solid',
          borderBottomColor: theme.vars.palette.primary.light
        }
      }
    }
  };
}
